"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backgroundColor = exports.actionMenuHeaderColor = exports.searchFilterBorderHoverColor = exports.searchFilterBorderColor = exports.searchBackground = exports.dialogBackgroundColor = exports.tabNavBorderColor = exports.headingTextColor = void 0;
const styled_components_1 = require("styled-components");
exports.headingTextColor = (0, styled_components_1.css) `rgb(128, 128, 128)`;
exports.tabNavBorderColor = (0, styled_components_1.css) `rgb(169, 169, 169);`;
exports.dialogBackgroundColor = (0, styled_components_1.css) `rgb(233, 236, 238);`;
// System/Pricing manager
exports.searchBackground = "#F1F1F1";
exports.searchFilterBorderColor = "rgb(217,217,217)";
exports.searchFilterBorderHoverColor = "rgb(198,198,198)";
// Action menu
exports.actionMenuHeaderColor = "rgb(147, 147, 147)";
exports.backgroundColor = "#fff";
//# sourceMappingURL=colors.js.map